import { AnyEventObject } from 'xstate';
import { patchData } from '~/utils/service';
import { Scope } from '../../../step-machine/types';
import { ShiftDetailsFormValues } from './types';
import { transformShiftDetailsFormToApi } from './utils';

const ROUTE_NAME = 'msaasDetails';

export const API_CALLS = {
  patch: async ({ input }: { input: Scope<ShiftDetailsFormValues> }) => {
    const event = input.event as AnyEventObject;
    return await patchData(ROUTE_NAME, {
      pathParams: { id: event.payload.values.id?.toString() || '' },
      data: event.payload.values,
      transformRequest: transformShiftDetailsFormToApi,
    });
  },
};
